<template>
  <div>
    <template v-if="shareLink">
      <p>Anyone with the link <b>can view</b> this folder and everything in it.</p>
      <div class="form-group">
        <div class="input-group">
          <span class="input-group-btn">
            <CopyButton
              @copied="shareLinkCopied"
              :copy-text="shareLink"
              success-text="Link copied"
              btn-class="btn-sm btn-primary">
              <i class="fa fa-link" aria-hidden="true"/> Copy Link
            </CopyButton>
          </span>
          <input
            :value="shareLink"
            type="text"
            class="input-sm form-control"
            readonly>
        </div>
      </div>
      <p>
        <a
          role="button"
          v-if="!updating"
          @click="toggleSharing(false)">Make private</a>
        <i v-else>Turning off sharing...</i>
      </p>
    </template>
    <template v-else>
      <p class="form-group">
        <tooltip v-if="shareStudentPermissions.block" text="You must have an active membership through your school or district to get a shareable link">
          <span style="display: inline-block"><button disabled class="btn btn-primary">Get Shareable Link</button></span>
        </tooltip>
        <button
          v-if="!shareStudentPermissions.block"
          class="btn btn-primary"
          :disabled="updating"
          @click="toggleSharing(true)">
          <i class="fa fa-link" aria-hidden="true"/> {{ updating ? 'Sharing...' : 'Get Shareable Link' }}
        </button>
      </p>
      <p><b>What is a shareable link?</b></p>
      <p>Anyone who has the shareable link for this folder <b>can view everything in it</b>. Only share the link with those who need it. To maintain privacy, do not post it in a publicly accessible place.</p>
      <p>You can turn sharing off for a folder at anytime, which will expire previous shareable links.</p>
    </template>
    <p class="text-danger" v-if="shareError">{{ shareError }}</p>
  </div>
</template>

<script>
import { CONTENT_TYPES, ACTION_TYPES, actionPermissions } from '@/util/access_visibility'
import { updateStudent } from '@/api/library'
import CopyButton from '@/components/CopyButton'
import { mapGetters } from 'vuex'

export default {
  name: 'StudentShareForm',
  components: {
    CopyButton
  },
  props: {
    studentUuid: {
      type: String,
      required: true
    },
    userUuid: {
      type: String,
      required: true
    },
    shareToken: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      updating: false,
      shareError: ''
    }
  },
  computed: {
    shareLink() {
      return this.shareToken
        ? window.location.origin +
            this.$router.resolve(
              {
                name: 'SharedStudentLibraryPage',
                params: { shareToken: this.shareToken }
              },
              true,
              true
            ).href
        : ''
    },
    ...mapGetters('user', ['authInfo']),
    shareStudentPermissions() {
      return actionPermissions(ACTION_TYPES.SHARE, CONTENT_TYPES.STUDENT, {}, this.authInfo)
    }
  },
  methods: {
    shareLinkCopied() {
      this.$sendEvent('Copied Share Link', { share_content_type: CONTENT_TYPES.STUDENT })
    },
    async toggleSharing(shareFlag) {
      if (
        !shareFlag &&
        !confirm(
          'Are you sure you want to make this folder private? Anyone who has a share link will no longer be able to use it.'
        )
      ) {
        return
      }
      this.updating = true
      this.shareError = ''

      try {
        let collection = await updateStudent({
          userUuid: this.userUuid,
          studentUuid: this.studentUuid,
          updateParams: {
            share: `${shareFlag}`
          }
        })

        this.$emit('update:shareToken', collection.share_token)
        this.updating = false
        this.$sendEvent('Toggled Student Sharing', { share: shareFlag })
      } catch (err) {
        this.shareError = err
        console.error(err)
        this.updating = false
      }
    }
  }
}
</script>
